import { drpRequest, towerDrpRequest } from '@/utils/request'

import {
    ExportPriceRuleItemParam,
    DrpPriceRuleParam,
    ImportPriceRuleItemParam,
    CreateDrpPriceRuleParam,
    DrpPriceRuleResult,
    LoadUsingGet1Params,
    UpdateDrpPriceRuleParam,
    PageDelLogUsingGetParams,
    ListDelLogResult,
    FindByLogIdUsingGetParams,
    ListTimeLineUsingGetParams,
    ListDrpPriceRuleTimeLineResult,
    SpecialPriceRuleConfigResult,
    QueryAutoloadingBySrcSkuIdParam,
    QueryAutoloadingBySrcSkuIdResult,
    GetProgressUsingGetParams,
    ListDrpPriceRuleResult,
    ItemCodesParam,
    QueryCombineSkuInfoResult,
    SpecialPriceRuleNewFunListResult,
} from '@servicesTypings/towerDrpRequest'

import {
    QueryLogTimeListUsingGetParams,
    QueryLogTimeListResult,
    LoadQualityChannelConfigLogUsingGetParams,
    LoadQualityChannelConfigLogResult,
    LoadDrpPriceConfigLogUsingGetParams,
    LoadDrpPriceConfigLogResult,
} from '@servicesTypings/drpRequest'

import {
    QueryDrpPriceRuleItemParam,
    DrpPriceRuleDetailResult,
    QueryDrpPriceRuleParams,
    DrpPriceRuleHeadResult,
    ModifyItemsParam,
    DelItemsParam,
    GetProgressParams,
    Progress,
} from '@servicesTypings/towerDrpRequestV3'

/**
 * 删除特殊价格策略
 */
export function deleteDrpPriceRuleUsingPOST1(data: number[]): API.Res<null> {
    return towerDrpRequest.post('/price/drpPriceRule/deleteList', { data })
}

/**
 * 根据策略id导出商品
 */
export function exportByRuleIdUsingPOST(data: ExportPriceRuleItemParam): API.Res<string> {
    return towerDrpRequest.post('/price/drpPriceRule/exportByRuleId', { data })
}

/**
 * 导出特殊价格策略
 */
export function exportExcelUsingPOST(data: DrpPriceRuleParam): API.Res<string> {
    return towerDrpRequest.post('/price/drpPriceRule/exportExcel', { data })
}

/**
 * 根据策略id导入商品
 */
export function importByRuleIdUsingPOST(data: ImportPriceRuleItemParam): API.Res<string> {
    return towerDrpRequest.post('/price/drpPriceRule/importByRuleId', { data })
}

/**
 * 根据策略id导入商品
 */
export function parseRuleItemsByExcel(data): API.Res<string> {
    return towerDrpRequest.post('/price/drpPriceRule/parseRuleItemsByExcel', { data })
}

/**
 * 新增特殊价格策略
 */
export function createDrpPriceRuleUsingPOST(data: CreateDrpPriceRuleParam): API.Res<null> {
    return towerDrpRequest.post('/price/drpPriceRule/insert', { data })
}

/**
 * 查询特殊价格策略详情
 */
export function loadUsingGET1(params: LoadUsingGet1Params): API.Res<ListDrpPriceRuleResult> {
    return towerDrpRequest.get('/price/drpPriceRule/load', { params })
}

/**
 * 修改特殊价格策略
 */
export function updateDrpPriceRuleUsingPOST(data: UpdateDrpPriceRuleParam): API.Res<null> {
    return towerDrpRequest.post('/price/drpPriceRule/update', { data })
}

/**
 * 分页查询删除的特殊价格策略日志列表
 */
export function pageDelLogUsingGET(params: PageDelLogUsingGetParams): API.Res<ListDelLogResult[]> {
    return towerDrpRequest.get('/price/drpPriceRuleLog/findDelList', { params })
}

/**
 * 根据日志id查询特殊价格策略日志详情
 */
export function findByLogIdUsingGET(params: FindByLogIdUsingGetParams): API.Res<DrpPriceRuleResult> {
    return towerDrpRequest.get('/price/drpPriceRuleLog/findByLogId', { params })
}

/**
 * 查询特殊价格策略日志操作时间轴列表
 */
export function listTimeLineUsingGET(params: ListTimeLineUsingGetParams): API.Res<ListDrpPriceRuleTimeLineResult[]> {
    return towerDrpRequest.get('/price/drpPriceRuleLog/findTimeList', { params })
}

/**
 * 查询特殊价格策略配置
 */
export function findPriceRuleConfigUsingGET(): API.Res<SpecialPriceRuleConfigResult> {
    return towerDrpRequest.get('/price/drpPriceRule/findPriceRuleConfig')
}

/**
 * 根据子商品编码列表查询自动加载的组合装商品信息
 */
export function queryAutoloadingBySrcSkuIdUsingPOST(
    data: QueryAutoloadingBySrcSkuIdParam,
): API.Res<QueryAutoloadingBySrcSkuIdResult[]> {
    return towerDrpRequest.post('/price/drpPriceRule/queryAutoLoadingBySrcSkuId', { data })
}

/**
 * 获取任务进度
 */
export function getProgressUsingGET(params: GetProgressUsingGetParams): API.Res<Progress> {
    return towerDrpRequest.get('/progress/getProgress', { params })
}

/**
 * 分页查询特殊价格策略
 */
export function listUsingPOST(data: DrpPriceRuleParam): API.Res<ListDrpPriceRuleResult[]> {
    return towerDrpRequest.post('/price/drpPriceRule/list', { data })
}

/**
 * 查询组合装商品信息
 */
export function queryCombineSkuInfoUsingPOST(data: ItemCodesParam): API.Res<QueryCombineSkuInfoResult[]> {
    return towerDrpRequest.post('/supplier/item/queryCombineSkuInfo', { data })
}

/**
 * 查询特殊价格策略是否可使用新功能
 */
export function querySpecialPriceRuleNewFunListUsingGET(): API.Res<SpecialPriceRuleNewFunListResult> {
    return towerDrpRequest.get('/price/drpPriceRule/querySpecialPriceNewFunList')
}

/**
 * 查询日志时间轴列表
 */
export function queryLogTimeListUsingGET(params: QueryLogTimeListUsingGetParams): API.Res<QueryLogTimeListResult[]> {
    return drpRequest.get('/drp/drpPriceConfigLog/queryLogTimeList', { params })
}

/**
 * 根据日志id查询优质分销商等级价日志详情
 */
export function loadQualityChannelConfigLogUsingGET(
    params: LoadQualityChannelConfigLogUsingGetParams,
): API.Res<LoadQualityChannelConfigLogResult> {
    return drpRequest.get('/drp/drpPriceConfigLog/loadQualityChannelConfigLog', { params })
}

/**
 * 根据日志id查询分销价格配置日志
 */
export function loadDrpPriceConfigLogUsingGET(
    params: LoadDrpPriceConfigLogUsingGetParams,
): API.Res<LoadDrpPriceConfigLogResult> {
    return drpRequest.get('/drp/drpPriceConfigLog/loadDrpPriceConfigLog', { params })
}

/**
 * 分页查询特殊价格策略-商品/款列表
 */
export function queryDrpPriceRuleItems(data: QueryDrpPriceRuleItemParam): API.Res<DrpPriceRuleDetailResult[]> {
    return towerDrpRequest.post('/price/drpPriceRule/queryDrpPriceRuleItems', { data })
}

/**
 * 查询特殊价格策略头部信息详情
 */
export function queryDrpPriceRule(params: QueryDrpPriceRuleParams): API.Res<DrpPriceRuleHeadResult> {
    return towerDrpRequest.get('/price/drpPriceRule/queryDrpPriceRule', { params })
}

/**
 * 修改策略明细列表
 */
export function modifyItems(data: ModifyItemsParam): API.Res<string> {
    return towerDrpRequest.post('/price/drpPriceRule/modifyItems', { data })
}

/**
 * 删除策略明细列表
 */
export function delItems(data: DelItemsParam): API.Res<string> {
    return towerDrpRequest.post('/price/drpPriceRule/delItems', { data })
}

/**
 * 获取任务进度
 */
export function getProgress(params: GetProgressParams): API.Res<Progress> {
    return towerDrpRequest.get('/progress/getProgress', { params })
}

/**
 * 查询款式编码基本售价状态
 */
export function queryStyleCodeSalePriceStatus(data: string[]): API.Res<string> {
    return towerDrpRequest.post('/supplier/item/queryStyleCodeSalePriceStatus', { data })
}

/**
 * 查询商品编码基本售价状态
 */
export function queryItemCodeSalePriceStatus(data: string[]): API.Res<string> {
    return towerDrpRequest.post('/supplier/item/queryItemCodeSalePriceStatus', { data })
}
